<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row class="divSubtitulo m-1">
      <b-col cols="10">
        <div>
          <p class="textoSubtitulo">HISTORIALES CLINICOS</p>
        </div>
      </b-col>
      <b-col>
        <div>
          <p style="text-align:end" class="textoSubtitulo">CÓDIGO</p>
        </div>
      </b-col>
    </b-row>

    <div>
      <b-row>
        <b-col :cols="tamanoCol">
          <b-col cols="12">
            <b-row>
              <b-col cols="8"> </b-col>
              <b-col cols="4" style="margin-left:77%;">
                <br/>
                <b-button v-if="esNinio" variant="ligth" class="button-circle shadow  text-icon m-2"
                          v-b-tooltip.hover.right.v-success
                          title="Hc niño"
                          @click="mostrarTipoHistoriaClinica(1, 0, true)"
                >
                  <em class="hcNinio_svg " style="width:18px"></em>
                </b-button>
                <b-button v-else variant="ligth" class="button-circle shadow  text-dentalia m-2"
                          v-b-tooltip.hover.right.v-success
                          title="Hc adulto"
                          @click="mostrarTipoHistoriaClinica(2, 0, true)"
                >
                  <em class="hcAdulto_svg" style="width:18px"></em>
                </b-button>
                <b-button variant="ligth" class="button-circle shadow  text-icon m-2"
                          v-b-tooltip.hover.right.v-sucess
                          title="Hc emergencia"
                          @click="mostrarTipoHistoriaClinica(3, 0, true)"
                >
                  <em class="hcEmergencia_svg" style="width:18px"></em>
                </b-button>

                <br>
                <br>
              </b-col>
            </b-row>
          </b-col>


          <b-col style=" text-align: -webkit-center;" cols="12">
            <div class="contenedorTablaSinColor" style="width: 100%">
            <b-table-simple sticky-header responsive>
              <b-thead class="columnasTablaSinColor">
                <b-tr>
                  <b-th style="text-align: center;" v-for="(field, index) in fields" :key="index">
                    {{field.label}}
                  </b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="(lst, i) in listaHistoriales" :key="i" >
                  <b-td style="text-align: center;">
                    {{lst.idHistoriaClinica}}
                   </b-td>
                  <b-td style="text-align: center;">
                    <label @click="cambiarCols(lst)" >{{lst.tipoHistorial}}</label>
                  </b-td>
                  <b-td style="text-align: center;">{{lst.clinica}}</b-td>
                  <b-td style="text-align: -webkit-center;">
                    <b-alert class="alerrr" variant="success"
                             show v-if="lst.estatus=== 'Vigente'"
                    ><b>{{lst.estatus}}</b></b-alert>
                    <b-alert class="alerrr" variant="danger"
                             show v-if="lst.estatus=== 'Expirado'"
                    ><b>{{lst.estatus}}</b></b-alert>
                  </b-td>
                  <b-td style="text-align: -webkit-center;">
                    <b-alert class="alerrr" variant="success"
                             show v-if="lst.estatusLlenado=== 'Completa'"
                    ><b>{{lst.estatusLlenado}}</b></b-alert>
                    <b-alert class="alerrr" variant="danger"
                             show v-if="lst.estatusLlenado=== 'Incompleta'"
                    ><b>{{lst.estatusLlenado}}</b></b-alert>
                  </b-td>
                  <b-td style="text-align: center;">{{lst.fechaExpedicion}} </b-td>
                  <b-td style="text-align: center;">{{lst.tiempoExpiracion}} </b-td>
                  <b-td style="text-align: center;">
                    <b-button v-if="tieneDatosLst"
                        pill size="sm" style="background-color:#1792b8; font-size: 10px;"
                        @click="mostrarTipoHistoriaClinica(lst.idTipoDenticion, lst.idHistoriaClinica, lst.sePuedeGuardar)"
                    >
                      <b-icon icon="eye" style="color:#FFFFFF">  </b-icon>
                    </b-button>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
              <span v-if="loaderAcciones">
                <b-spinner variant="primary"></b-spinner>
              </span>
            <b-alert v-if="!loaderAcciones && !tieneDatosLst " variant="success" show>El paciente aún no cuenta con Historiales clínicos</b-alert>
          </div>
        </b-col>
        </b-col>


        <b-col :cols="tamanoCol1">
          <b-card
              v-if="tamanoCol1 !== 0 && !verDetalleCambio"
              style="border-radius: 10px; margin: 25px -15px; box-shadow: 0px 6px 17px -4px rgba(0, 0, 0, 0.12);  text-align: left;"
          >
            <label style="margin-bottom: 1px;"> Actividad </label>
            <b-icon @click="cambiarCols(null)" icon="x-circle"
                    style="position: absolute; margin-left: 73%; margin-top: -15px; cursor: pointer; color:red"
            ></b-icon>

            <hr>
            <span class="logo-inicial" @click="obtenerDetalleCambio()">{{ usrName | formatoIniciales}}</span>
            <span > {{infoCard.nombreUsuario}} </span>
            <span style="font-size:10px;"> {{infoCard.fechaModificacion | formatoFechaHoraTexto}} </span>


          </b-card>
          <b-card v-if="verDetalleCambio"
                  style="border-radius: 10px; margin: 25px -15px; box-shadow: 0px 6px 17px -4px rgba(0, 0, 0, 0.12);  text-align: left;"
          >
            <b-icon @click="cambiaAActividad()" icon="arrow-left-circle" animation="cylon" ></b-icon>
            <label style="margin-bottom: 1px;margin-left: 6px;"> Detalle de la actividad </label>
            <hr>

            <span style="font-size:10px; color:rgb(23, 146, 184);"><b> Cambios de {{infoCard.nombreUsuario}} </b> </span>
            <label style="font-size:8px;"> {{infoCard.fechaModificacion | formatoFechaHoraTexto}} </label>

            <br>

              <span v-if="loaderCambio">
                <b-spinner small variant="primary"></b-spinner>
              </span>
              <b-alert style="font-size: 12px;" v-if="!loaderCambio && listCambios.length === 0" variant="info" show>
                No hay detalle de cambio por campo
              </b-alert>



            <b-card no-body class="mb-1" v-for="(cambio, index) in listCambios" :key="index">
              <b-card-header header-tag="header" class="p-1" role="tab">

                  <b-icon :id="index" :key="index" v-if="cambio.mostrarIcono" style="z-index: 10;position: absolute;margin-left: 88%; margin-top:21px;"
                          icon="chevron-down"
                  ></b-icon>
                  <b-icon :id="index" :key="index" v-else style="z-index: 10;position: absolute;margin-left: 88%; margin-top:21px;"
                           icon="chevron-up"
                  ></b-icon>


                <b-button block v-b-toggle="'cambio-' + cambio.idRHistoriaClinica"  variant="outline-info" style="text-align: left;"
                          @click="cambio.mostrarIcono = !cambio.mostrarIcono"   >
                  <span style="font-size:10px">Campo modificado: {{cambio.nombreCampo}}</span>
                  <br>
                  <span style="font-size:10px">Sección: {{cambio.nombreClasificacion}}</span>
                </b-button>

              </b-card-header>

              <b-collapse :id="'cambio-' + cambio.idRHistoriaClinica" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <span v-if="cambio.nuevoValor === true" style="font-size:10px">Nuevo valor: {{cambio.nuevoValor}}</span>
                  <span style="font-size:10px">Nuevo valor: {{cambio.nuevoValor}}</span>
                  <br>
                  <span style="font-size:10px">Valor anterior: {{cambio.valorAnterior}}</span>
                </b-card-body>
              </b-collapse>
            </b-card>




          </b-card>
        </b-col>
      </b-row>
    </div>

  </div>
</template>

<script>
export default {
  name: "BandejaHcs",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    fields: [
      {key: "idHistoriaClinica", label: "ID HC", sortable: true},
      {key: "tipoHistorial", label: "Tipo Historial", sortable: true},
      {key: "clinica", label: "Clínica", sortable: true},
      {key: "estatus", label: "Estatus", sortable: true},
      {key: "estatusLlenado", label: "Estatus llenado", sortable: true},
      {key: "fechaExpedicion", label: "Fecha Expedición", sortable: true},
      {key: "tiempoExpiracion", label: "Tiempo Expiración", sortable: true},
      {key: "acciones", label: "Acciones"},
    ],
    verDetalleCambio: false,
    showObservaciones: false,
    cargandoHistoriales: false,
    listaHistoriales:[],
    esNinio: false,
    tamanoCol:12,
    tamanoCol1:0,
    usrName: null,
    infoCard:[{
      nombreUsuario: null,
      fechaModificacion: null,
      loaderAcciones:false,
    }],
    idHistoriaClinica: 0,
    listIds:[],
    listCambios: [],
    loaderCambio:false,
    tieneDatosLst: false,
  }),
  props:{
    idPaciente: Number
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerHistorialesPaciente();
    /* this.mostrarTipoHistoriaClinica(0); */
  },
  methods:{
    /*cambiarIconos(index){
      this.showObservaciones = !this.showObservaciones
    },*/
    cambiaAActividad(){
      this.verDetalleCambio = false;
    },
    obtenerDetalleCambio(){
      this.verDetalleCambio = true;
      this.loaderCambio = true;
      this.listCambios =[];

      // eslint-disable-next-line no-unused-vars
      let idHistoriaAnterior = [];
      this.listIds.forEach(id => {
        if (id < this.idHistoriaClinica ){
          idHistoriaAnterior.push(id)
        }
      })

      if (idHistoriaAnterior === null || idHistoriaAnterior === undefined){
        idHistoriaAnterior[0] = 0;
      }

      let urlMedio = this.$api + "paciente/detalleCambioHc?idHistoriaClinica=" + this.idHistoriaClinica
          + "&idPaciente=" + this.idPaciente
          + "&idHistoriaAnterior=" + idHistoriaAnterior[0];

      this.$http.get(urlMedio).then((response) => {
        if (response.data.data) {
          this.listCambios = response.data.data
          this.loaderCambio = false;
        }
      })
    },
    cambiarCols(dtos){
      if (dtos === null ){
        this.tamanoCol1 = 0
        this.tamanoCol = 12
      }else{
        this.tamanoCol1 = 4
        this.tamanoCol = 8
        this.verDetalleCambio = false;

        this.idHistoriaClinica = dtos.idHistoriaClinica;

        this.usrName = dtos.nombreUsuario;
        this.infoCard.nombreUsuario = dtos.nombreUsuario;
        this.infoCard.fechaModificacion = dtos.fechaModificacion;
      }



    },
    mostrarTipoHistoriaClinica(tipoHc, idHc, activarGuardar){
      console.log("llega al metodo=" )
      this.$emit("mostrarTipoHistoriaClinica", tipoHc, idHc, activarGuardar, true);
    },
    obtenerHistorialesPaciente() {
      this.loaderAcciones = true;
      this.cargandoHistoriales = true;
      const parametros = {idPaciente: this.idPaciente}
      let urlMedio = this.$api + "paciente/historialPacienteHcs";
      this.$http.post(urlMedio, parametros).then((response) => {
        if (response.data.data) {

          this.listaHistoriales = response.data.data;
          this.esNinio = this.listaHistoriales[0].esNinio;
          this.tieneDatosLst = this.listaHistoriales[0].listTieneDatos;
          this.loaderAcciones = false;

          this.listaHistoriales.forEach(x => {
            this.listIds.push(x.idHistoriaClinica);
          })

        }
      })
          /*.catch((err) => {
            this.errorMensaje(err);
          })*/
          .finally(() => {
            this.loaderAcciones = false;
          });
    },
  }
}
</script>

<style scoped>
.columnasTablaSinColor {
  font-size: 14px;
  font-weight: bold;
  color: #5d5d5d !important;
  text-transform: capitalize !important;
}
.table.b-table > thead > tr > .table-b-table-default {
   color: #090909 !important;
   background-color: #ffffff !important;
}
.alerrr {
  padding: 6px;
  width: 80px;
  border-radius: 20px;
}
.alert-success {
  color: #2fb34d;
  background-color: #d4edda;
  border-color: #c3e6cb;
  opacity: 0.7;
}
.logo-inicial {
  background-color: green;
  color: white;
  font-size: 14px;
  padding: 10px;
  border-radius: 100%;
  font-weight: bold;
}
.card-header {
  color: #053672 !important;
  background-color: #ffffff !important;
}
.btn-outline-info {
  color: #000000;
  border-color: #17a2b8;
}
.mb-1, .my-1 {
  margin-bottom: 1em !important;
}

</style>
